var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.profile
    ? _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          {
            staticClass: "form-container d-flex flex-column align-items-center",
          },
          [
            _c("h2", { staticClass: "title-text mx-auto" }, [
              _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mx-0" }, [
              _c(
                "div",
                { staticClass: "col px-4" },
                [
                  _c(
                    "ValidationObserver",
                    { ref: "passwordObserver" },
                    [
                      _c(
                        "form",
                        { attrs: { id: "changePassword" } },
                        [
                          _c("v-input", {
                            staticClass: "d-none",
                            attrs: {
                              type: "text",
                              autocomplete: "username",
                              value: _vm.profile.mail,
                            },
                          }),
                          _vm._v(" "),
                          _vm.profile.passwordExists
                            ? _c("v-input", {
                                staticClass: "input-w-default mb-0 mt-2",
                                attrs: {
                                  ind: "6",
                                  type: _vm.openCurrentPassword
                                    ? "text"
                                    : "password",
                                  name: "currentPassword",
                                  placeholder: _vm.$t(
                                    "placeholder.oldPassword"
                                  ),
                                  icon: _vm.$getInputIcon(
                                    _vm.currentPassword,
                                    "password"
                                  ),
                                  rules: "required|validPassword",
                                  autocomplete: "current-password",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "password",
                                      fn: function () {
                                        return [
                                          _c("password-eye", {
                                            model: {
                                              value: _vm.openCurrentPassword,
                                              callback: function ($$v) {
                                                _vm.openCurrentPassword = $$v
                                              },
                                              expression: "openCurrentPassword",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3574714260
                                ),
                                model: {
                                  value: _vm.currentPassword,
                                  callback: function ($$v) {
                                    _vm.currentPassword = $$v
                                  },
                                  expression: "currentPassword",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-input", {
                            staticClass: "input-w-default mb-0 mt-2",
                            attrs: {
                              ind: "7",
                              type: "password",
                              name: "password",
                              placeholder: _vm.$t("placeholder.newPassword"),
                              icon: _vm.$getInputIcon(_vm.password, "password"),
                              rules: {
                                required: true,
                                min: 6,
                                newPassword: _vm.currentPassword,
                              },
                              autocomplete: "new-password",
                            },
                            model: {
                              value: _vm.password,
                              callback: function ($$v) {
                                _vm.password = $$v
                              },
                              expression: "password",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-input", {
                            staticClass:
                              "input-w-default input-w-default mb-0 mt-2",
                            attrs: {
                              ind: "8",
                              type: "password",
                              name: "passwordConfirm",
                              placeholder: _vm.$t("placeholder.repeatPassword"),
                              icon: _vm.$getInputIcon(
                                _vm.passwordConfirm,
                                "password"
                              ),
                              rules: "required|confirmed:password",
                              autocomplete: "new-password",
                            },
                            model: {
                              value: _vm.passwordConfirm,
                              callback: function ($$v) {
                                _vm.passwordConfirm = $$v
                              },
                              expression: "passwordConfirm",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "center-element change-button",
                          on: { click: _vm.changePassword },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("button.save")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.profile.passwordExists
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "center-element small text-link mb-2",
                              attrs: { to: "/restore/request" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.forgotPassword")) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }